{
  "title": "Beacon of Hope",
  "source": "Player's Handbook",
  "levelAndSchool": "3rd-level abjuration",
  "level": 3,
  "castingTime": "1 action",
  "range": "30 feet",
  "components": "V, S",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "This spell bestows hope and vitality. Choose any number of creatures within range. For the duration, each target has advantage on Wisdom saving throws and death saving throws, and regains the maximum number of hit points possible from any healing."
  ],
  "spellLists": ["cleric"]
}
